import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TextareaComponent } from '@modules/sms/components/templates/textarea/textarea.component';

const routes: Routes = [
  {
    path: 'sendTrial',
    loadChildren: () => import('../../views/sms/sms-send/sms-send.module').then(m => m.SmsSendModule)
  },
  {
    path: 'send',
    loadChildren: () => import('../../views/sms/sms-sendFull/sendFull.module').then(m => m.SmsSendFullModule)
  },
  {
    path: 'templates',
    loadChildren: () => import('../../modules/sms/templates/sms-template-list/sms-template-list.module').then(m => m.SmsTemplateListModule)
  },
  {
    path: 'textarea',
    component: TextareaComponent
  },
  {
    path: 'in',
    loadChildren: () => import('../../views/smsin/smsin.module').then(m => m.SmsinModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmsRoutingModule {}
